export function parseRepoKey(key: string): {
  provider: 'github' | 'gitlab';
  installationId: number;
  repoFullName: string;
  projectId?: number;
  connectionId?: string;
} {
  if (key.startsWith('gitlab:')) {
    const parts = key.slice(7).split(':');
    const connectionId = parts[0]!;
    const projectId = Number(parts[1]);
    const repoFullName = parts.slice(2).join(':');
    return {
      provider: 'gitlab',
      installationId: 0,
      repoFullName,
      projectId,
      connectionId,
    };
  }
  let k = key;
  if (k.startsWith('github:')) k = k.slice(7);
  const sepIdx = k.indexOf(':');
  if (sepIdx === -1) {
    return { provider: 'github', installationId: NaN, repoFullName: k };
  }
  return {
    provider: 'github',
    installationId: Number(k.slice(0, sepIdx)),
    repoFullName: k.slice(sepIdx + 1),
  };
}

export function toRepoKey(repo: {
  provider?: 'github' | 'gitlab';
  installationId?: number;
  fullName: string;
  projectId?: number;
  connectionId?: string;
}): string {
  if (repo.provider === 'gitlab') {
    return `gitlab:${repo.connectionId}:${repo.projectId}:${repo.fullName}`;
  }
  return `${repo.installationId ?? 0}:${repo.fullName}`;
}
